var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.628021,
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_7937_67703)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7937_67703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 26.628V28.628C35.5 30.4845 34.7625 32.265 33.4497 33.5778C32.137 34.8905 30.3565 35.628 28.5 35.628M28.5 35.628C26.6435 35.628 24.863 34.8905 23.5503 33.5778C22.2375 32.265 21.5 30.4845 21.5 28.628V26.628M28.5 35.628V39.628M24.5 39.628H32.5M28.5 17.628C27.7044 17.628 26.9413 17.9441 26.3787 18.5067C25.8161 19.0693 25.5 19.8324 25.5 20.628V28.628C25.5 29.4237 25.8161 30.1867 26.3787 30.7493C26.9413 31.312 27.7044 31.628 28.5 31.628C29.2956 31.628 30.0587 31.312 30.6213 30.7493C31.1839 30.1867 31.5 29.4237 31.5 28.628V20.628C31.5 19.8324 31.1839 19.0693 30.6213 18.5067C30.0587 17.9441 29.2956 17.628 28.5 17.628Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7937_67703",
    x1: 0.5,
    y1: 5.35573,
    x2: 13.5303,
    y2: 67.3857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4675FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05D6B6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7937_67703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16.5 16.628)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolIcon);
export default __webpack_public_path__ + "static/media/ToolIcon.e272f791fc5d8ac0736ff55156d9e53b.svg";
export { ForwardRef as ReactComponent };